import { camelCase } from 'lodash'

const createMutationSet = type => ({
  BASE: `${type}`,
  urlKey: `${camelCase(type)}Url`,
  stateKey: `${camelCase(type)}State`,
  promiseKey: `${camelCase(type)}Promise`,
  cancelSource: `${camelCase(type)}cancelSource`,
  statusCodeKey: `${camelCase(type)}StatusCode`,
  errorMessageKey: `${camelCase(type)}ErrorMessage`,
  dataKey: `${camelCase(type)}Data`,
  requestCount: `${camelCase(type)}RequestCount`,
})

const MESSAGES = createMutationSet('MESSAGES')
const MESSAGES_DETAIL = createMutationSet('MESSAGES_DETAIL')
const MESSAGES_UPDATE = createMutationSet('MESSAGES_UPDATE')
const MESSAGES_STATUS = createMutationSet('MESSAGES_STATUS')
const MESSAGES_ATTACHMENTS = createMutationSet('MESSAGES_ATTACHMENTS')

const DECREASE_UNREAD_TOTAL = 'DECREASE_UNREAD_TOTAL'
const SET_MESSAGE_PREVIEW_DATA = 'SET_MESSAGE_PREVIEW_DATA'

export default {
  MESSAGES,
  MESSAGES_DETAIL,
  MESSAGES_UPDATE,
  MESSAGES_STATUS,
  MESSAGES_ATTACHMENTS,
  DECREASE_UNREAD_TOTAL,
  SET_MESSAGE_PREVIEW_DATA,
}
